import React from 'react';

const CTASection = ({ onBookClick }) => {
  return (
    /* Final light section before the dark footer — mint accent band for energy */
    <section
      id="contact"
      className="py-24 md:py-28 relative overflow-hidden"
      style={{
        background: '#EEFAF6',
        borderTop: '1px solid rgba(128,229,203,0.40)',
      }}
    >
      {/* Stronger mint glow at centre */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at 50% 50%, rgba(128,229,203,0.22) 0%, transparent 65%)',
        }}
      />

      <div className="container relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          {/* Mint accent line above heading */}
          <div
            className="w-12 h-1 rounded-full mx-auto mb-6"
            style={{ background: '#80E5CB' }}
          />
          <h2
            className="text-[#00001E] mb-5"
            style={{ fontSize: 'clamp(36px, 7vw, 52px)' }}
          >
            Ready to book?
          </h2>
          <p className="text-[#2B3879] text-xl md:text-2xl mb-10 leading-relaxed">
            Takes 2 minutes. We come to you.
          </p>

          <div className="mb-6">
            <button
              onClick={onBookClick}
              style={{
                background: '#80E5CB',
                color: '#00001E',
                border: 'none',
                borderRadius: '8px',
                padding: '17px 44px',
                fontWeight: '700',
                fontSize: '17px',
                textTransform: 'uppercase',
                letterSpacing: '0.08em',
                fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 8px 32px rgba(128,229,203,0.45)',
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 14px 44px rgba(128,229,203,0.60)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 8px 32px rgba(128,229,203,0.45)';
              }}
            >
              Book a Collection
            </button>
          </div>

          <p className="text-[#2B3879] text-sm">
            Questions? Call us at{' '}
            <a
              href="tel:+61420424290"
              className="font-semibold hover:underline"
              style={{ color: '#00001E' }}
              onClick={() => {
                if (window.gtag) {
                  window.gtag('event', 'click_phone', {
                    event_category: 'engagement',
                    event_label: 'Phone number clicked',
                  });
                }
              }}
            >
              +61 420 424 290
            </a>
            {' '}or send a message.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
